'use client';

import { LabType } from '@/types/labs';
import ImageAdaptive from '@/components/ImageAdaptive';

interface LabBadgeProps {
    labType: LabType;
    baseWidth: number;
    breakpoints?: {
        md?: number;
        lg?: number;
        xl?: number;
    };
}

export default function LabBadge({ labType, baseWidth, breakpoints }: LabBadgeProps) {
    if (!labType || labType === 'general') return null;

    const imageMap: Record<'official' | 'certified', string> = {
        official: '/images/lab/official.svg',
        certified: '/images/lab/certified.svg',
    };

    const src = imageMap[labType];
    if (!src) return null;

    return <ImageAdaptive src={src} baseWidth={baseWidth} breakpoints={breakpoints} />;
}
